import { jsxs as l, jsx as C } from "react/jsx-runtime";
function t(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M13.76 10.17C13.76 10.17 13.81 10.25 13.85 10.29C13.89 10.32 13.94 10.34 14 10.34C14.06 10.34 14.11 10.32 14.15 10.29C14.19 10.26 14.22 10.22 14.24 10.17C14.26 10.12 14.27 10.07 14.28 10.02C14.28 9.97 14.29 9.91 14.29 9.86C14.29 9.81 14.29 9.77 14.28 9.72C14.27 9.67 14.25 9.62 14.23 9.58C14.21 9.54 14.18 9.5 14.14 9.47C14.1 9.44 14.05 9.43 13.99 9.43C13.93 9.43 13.88 9.44 13.84 9.47C13.8 9.5 13.77 9.53 13.75 9.58C13.73 9.62 13.71 9.67 13.7 9.72C13.7 9.77 13.69 9.82 13.69 9.86C13.69 9.91 13.69 9.96 13.7 10.02C13.71 10.08 13.72 10.13 13.74 10.17H13.76Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.28 11.62C14.25 11.57 14.22 11.52 14.17 11.49C14.12 11.46 14.07 11.44 14 11.44C13.93 11.44 13.88 11.46 13.84 11.49C13.79 11.52 13.76 11.57 13.73 11.62C13.7 11.67 13.68 11.73 13.67 11.79C13.66 11.85 13.65 11.91 13.65 11.96C13.65 12.03 13.65 12.11 13.67 12.18C13.68 12.25 13.7 12.32 13.72 12.38C13.74 12.44 13.78 12.48 13.83 12.52C13.88 12.56 13.93 12.57 14 12.57C14.07 12.57 14.13 12.55 14.17 12.52C14.22 12.48 14.25 12.44 14.28 12.38C14.31 12.32 14.32 12.26 14.33 12.18C14.34 12.11 14.35 12.03 14.35 11.96C14.35 11.91 14.35 11.85 14.33 11.79C14.32 11.73 14.3 11.67 14.27 11.62H14.28Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14 7C11.79 7 10 8.79 10 11C10 13.21 11.79 15 14 15C16.21 15 18 13.21 18 11C18 8.79 16.21 7 14 7ZM15.62 12.78C15.52 12.97 15.39 13.13 15.22 13.27C15.05 13.41 14.87 13.51 14.65 13.58C14.44 13.65 14.22 13.69 13.99 13.69C13.76 13.69 13.54 13.65 13.33 13.58C13.12 13.51 12.93 13.41 12.76 13.27C12.59 13.13 12.46 12.97 12.36 12.78C12.26 12.59 12.21 12.38 12.21 12.14C12.21 11.84 12.29 11.58 12.43 11.36C12.58 11.14 12.8 10.99 13.08 10.89C12.82 10.8 12.62 10.67 12.49 10.48C12.36 10.29 12.3 10.06 12.3 9.78C12.3 9.55 12.34 9.35 12.43 9.17C12.52 8.99 12.64 8.83 12.8 8.71C12.95 8.58 13.13 8.49 13.33 8.42C13.53 8.35 13.75 8.32 13.97 8.32C14.19 8.32 14.41 8.35 14.61 8.42C14.81 8.49 14.99 8.59 15.14 8.71C15.29 8.84 15.42 8.99 15.51 9.17C15.6 9.35 15.64 9.56 15.64 9.78C15.64 10.06 15.58 10.29 15.45 10.48C15.32 10.67 15.13 10.8 14.86 10.88C15.14 10.99 15.36 11.15 15.51 11.36C15.66 11.58 15.73 11.84 15.73 12.14C15.73 12.37 15.68 12.59 15.58 12.78H15.62Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  t as default
};
